import { css } from '@emotion/react';

const container = css`
  height: 100%;
`;

export default {
  container,
};
